import { Page } from "@iq/models";

function Payments() {
	return (
		<Page>
		</Page>
	);
}


export default Payments;